import { render, staticRenderFns } from "./studentDetailNew.vue?vue&type=template&id=cdbbd166&scoped=true"
import script from "./studentDetailNew.vue?vue&type=script&lang=js"
export * from "./studentDetailNew.vue?vue&type=script&lang=js"
import style0 from "./studentDetailNew.vue?vue&type=style&index=0&id=cdbbd166&prod&scoped=true&lang=css"
import style1 from "./studentDetailNew.vue?vue&type=style&index=1&id=cdbbd166&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbbd166",
  null
  
)

export default component.exports